import { useMemo } from "react";

/**
 * Controlled dropdown for G-sportkampen dynamic filters.
 * Unlike FilterDropdown, this component is controlled (value prop drives display)
 * to support dynamic option reset behavior.
 */
export const FilterDropdownGSportkampen = ({ filter, onChange }) => {
  const options = useMemo(() => {
    if (!filter.options) return [];
    
    return filter.options.map((option, index) => (
      <option
        key={`option_${index}`}
        value={filter.values?.[index] ?? option}
      >
        {option}
      </option>
    ));
  }, [filter.options, filter.values]);

  return (
    <div className={`col-sm-${filter.gridWidth || 4}`}>
      <label>
        <strong>{filter.title}</strong>
      </label>
      <select
        className="c-input__field c-toggle-label"
        value={filter.value || ""}
        onChange={(evt) => onChange(filter.property, evt.target.value)}
      >
        <option value="">{filter.defaultValue || "Alles"}</option>
        {options}
      </select>
    </div>
  );
};
